import { IAppDefinition, IAppFiles, IAppService } from "../../../apps/types"
import { IOmniaShell } from "../../../shell"
import { Dialog } from "../../../shell/dialog"
import { IOmniaSettingsKey } from "../../../types"
import { defineDirective } from "../../../utils/angular"
import { IFileSelectionContext } from "../types"

/// <reference path="../../../shell/dialog.ts" />

interface Provider {
    key: string
    name: string
    logo: string
}
export type IFileSelectionParameters =
    | {

        type: "session"

        session: IAppFiles
        provider: Provider

        multipleSelection: boolean
        canSelectFolders: boolean

    }
    | {

        type: "app"

        app: IAppDefinition

        multipleSelection: boolean
        canSelectFolders: boolean

    }


/** @internal */
export class DialogCtrl extends Dialog {

    static create(): ng.IDirective {
        return defineDirective(DialogCtrl, "shared/components/files/dialog/dialog.html")
    }

    provider: Provider
    session: IAppFiles
    selectionContext: IFileSelectionContext

    private selectionSetting: IOmniaSettingsKey

    static $inject = ["$scope", "OmniaShell", "OmniaApps"]

    constructor($scope: ng.IScope, shell: IOmniaShell, private readonly appSvc: IAppService) {
        super($scope, shell)
    }

    $onInit() {

        const parameters: IFileSelectionParameters = this.arguments

        const setup = () => {

            this.selectionSetting = this.shell.getSession().getSettings("files.selection").getKey(`${this.provider.key}.lastPath`)

            this.selectionContext = {
                multipleSelection: parameters.multipleSelection,
                canSelectFolders: parameters.canSelectFolders,
                lastPath: this.selectionSetting.get()
            }

        }


        if (parameters.type == "session") {

            this.session = parameters.session
            this.provider = parameters.provider

            setup()

        }
        else {

            const { app } = parameters

            this.provider = {
                name: app.name,
                logo: app.icon ?? app.logo,
                key: `app:${app.appId}`
            }

            setup()

            this.appSvc.getFiles(app).then(session => this.session = session)

        }


    }

    close() {
        super.close([])
    }

    isLoading() {
        const f = this.selectionContext?.isLoading
        return f?.() ?? true
    }

    canRefresh() {
        const f = this.selectionContext?.canRefresh
        return f?.()
    }

    refresh() {
        const refresh = this.selectionContext?.refresh
        return refresh?.()
    }

    canSelectAll(select: boolean) {
        const f = this.selectionContext?.canSelectAll
        const files = this.selectionContext?.files?.length
        return f && f(select) && (
            select ? !files : files
        )
    }

    selectAll(select: boolean) {
        const f = this.selectionContext?.selectAll
        return f && f(select)
    }

    canConfirm(): boolean {
        return this.selectionContext.files && this.selectionContext.files.length > 0
    }

    confirm() {
        this.selectionSetting.set(this.selectionContext.currentPath)
        super.close(this.selectionContext.files)
    }

}
